import { createFileRoute } from "@tanstack/react-router";
import NyokaPowellRobinson from "@/pages/NyokaPowellRobinson";
export const Route = createFileRoute("/nyoka-powell-robinson")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Nyoka Powell Robinson | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Meet Nyoka Powell Robinson, a dedicated clinician at Neuro Wellness TMS in Coral Springs, FL specializing in depression and TMS care Free consultation.",
        },
        {
          property: "og:title",
          content: "Nyoka Powell Robinson | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Meet Nyoka Powell Robinson, a dedicated clinician at Neuro Wellness TMS in Coral Springs, FL specializing in depression and TMS care Free consultation.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/nyoka-powell-robinson",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/nyoka-powell-robinson",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <NyokaPowellRobinson />;
}
